import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import { func, string, shape, arrayOf } from 'prop-types';
import DefaultLoading from '../../Loading';
import { FEATURE_KEY_ID } from '../../../config';
import './Map.css'
import { getMapConfig } from '../../../services/projectService';

const Loading = styled(DefaultLoading)`
  margin: 60px auto;
  justify-content: center;
`;

// TODO
// - handle geoserverkey error
function Map({crs, mapData, zoomedItemId, onSelectedMedia}) {
    const [isLoading, setLoading] = useState(true);
    const [isGenerated, setGenerated] = useState(false);
    const [mapConfig, setMapConfig] = useState(null)

    useEffect(() => {
      getMapConfig("mediaMap")
        .then(data => {
          setMapConfig(data.config);
          console.log("config");
          setLoading(false);
        });
    }, []);

    useEffect(() => {
        if (zoomedItemId) {
            GIS.Layer.getFeatureExtentByID('subproject', zoomedItemId, {attribute: FEATURE_KEY_ID},
                (minx, miny, maxx, maxy) => GIS.Map.zoomToExtent([minx, miny, maxx, maxy],15)
            );
        }
    }, [zoomedItemId])

    useEffect(() => {
        if (isGenerated && mapData) {
            let extent = []
            mapData.map(property => {
                try {
                    GIS.Layer.getFeatureExtentByID('subproject', property.properties.id, {attribute: FEATURE_KEY_ID},
                        (minx, miny, maxx, maxy) => {extent = GIS.Projection.extendExtent([minx, miny, maxx, maxy], extent)}
                    );
                } catch (Error) {}
            })
            if (extent.length > 0) {
                GIS.Map.zoomToExtent(extent);
            }
        }
    }, [isGenerated, mapData])

    // TODO fix data refresh
    useEffect(() => {
        if (!isGenerated && !isLoading) {
            /* global GIS */
            console.log("init")
            GIS.Projection.init(mapConfig.projection);
            GIS.Style.init(mapConfig.style);
            GIS.Layer.init(mapConfig.layer, mapConfig.group);
            GIS.Control.init(mapConfig.control);
            GIS.Interaction.init(mapConfig.map);
            GIS.Map.init(mapConfig.map, mapConfig.view);

            GIS.Interaction.setCallback('Identify', {}, (X, Y) => {
                const scale = GIS.Map.getScale();
                // 250 adjusted based on icon size
                const radius = scale / 250;
                GIS.Layer.getFeaturesIDsInRadius('subproject', [X,Y], radius,{attribute: FEATURE_KEY_ID}, iDs => {
                    const media = mapData.map(el => el.properties).filter(feature => iDs.includes(feature[FEATURE_KEY_ID]))

                    if(media.length > 0) {
                        onSelectedMedia(media);

                        iDs.map(id => {
                            GIS.Layer.setFeatureStyleByID('subproject', 'multimedia_select', id, {attribute: FEATURE_KEY_ID})
                        });
                    }
                })
            })
            setGenerated(true);
        }

        return function cleanup() {
            if (isGenerated) {
                GIS.Layer.clear();
                GIS.Interaction.clear();
                GIS.Control.clear();
                setGenerated(false);
            }
        };
    }, [isGenerated, isLoading]);

    useEffect(() => {
      if(isGenerated) {
        GIS.Layer.removeFeatures('subproject');
        GIS.Layer.addFeatures('subproject', {
          type: "FeatureCollection",
          name: "Multimedia content",
          features: mapData,
          crs,
        });

        try {
            const extent = GIS.Layer.getLayerExtent('subproject');
            GIS.Map.zoomToExtent(extent);
        } catch (e) {
            console.log("We don't have any media related to you.")
        }
      }
    }, [isGenerated, crs, mapData]);

    return (
      <>
        { isLoading && (
          <Loading message="Loading geoserver key..." />
        )}
        <div className="cfm-map" id="map"></div>
      </>
    )
}

Map.propTypes = {
  crs: shape({}),
  mapData: arrayOf(shape({})).isRequired,
  zoomedItemId: string,
  onSelectedMedia: func.isRequired,
};

Map.defaultProps = {
  crs: {
    type: "EPSG",
    properties: {
      code: 4326
    }
  },
  zoomedItemId: null,
};

export default Map;